import React, {useState} from 'react'
import {Button, Col, Form, Modal, Row} from 'react-bootstrap';
import {useFormik} from 'formik';
import {formSchema} from './BusinessSchemaValidation';
import axios from '../../utils/axios';
import InputMask from 'react-input-mask';
import {toast, ToastContainer} from "react-toastify";
import Select from 'react-select';
import imageUrl from '../../utils/imageUrl';

function BusinessEditModal({businessData, handler}) {
    const [show, setShow] = useState(false);
    const [selectedOptions, setSelectedOptions] = useState([]);

    let options = [
        'Automotive',
        'Auto Accessories',
        'Auto Dealers – New',
        'Auto Dealers – Used',
        'Auto Detailing & Car wash',
        'Auto Body Shop & Paint',
        'Petrol & Gas Station',
        'Electric Vehicle Charging Station',
        'Hydrogen & Alternative Fuel Station',
        'Motorcycle Sales & Repair',
        'Car Rental & Leasing',
        'Auto Service, Repair & Parts',
        'Towing',
        'Tire Shop',
        'Parking',
        'Business Support & Supplies',
        'Consultants',
        'Employment Agency',
        'Marketing & Communications',
        'Office Supplies',
        'Printing & Publishing',
        'Computers & Electronics',
        'Computer Programming & Support',
        'Consumer Electronics & Accessories',
        'Networking Specialist',
        'Home Services',
        'Antiques & Collectibles',
        'Contractors',
        'Cleaning',
        'Crafts, Hobbies & Sports',
        'Electricians',
        'Home Furnishings',
        'Handyman',
        'Home Goods',
        'Home Improvements & Repairs',
        'Heating & Air Conditioning/HVAC',
        'Landscape & Lawn Service',
        'Keys & Locksmiths',
        'Pest Control',
        'Plumbers',
        'Pressure Washers',
        'Pool Supplies & Service',
        'Roofing',
        'Internet Service Providers',
        'Television Service Providers',
        'House Sitters',
        'Security System & Services',
        'Construction & Contractors',
        'Architects,Landscape Architects, Engineers & Surveyors',
        'Home Inspectors',
        'Home Automation',
        'Chimney Sweeps',
        'Excavation Services',
        'Fences & Gates',
        'Blasting & Demolition',
        'Building Materials & Supplies',
        'Construction Companies',
        'Furniture Assembly',
        'Garage Door Services',
        'Cabinetry',
        'Drywall Installation & Repair',
        'Windows Installation',
        'Electricians',
        'Engineer, Survey',
        'Environmental Assessments Inspectors',
        'Plaster & Concrete',
        'Painters',
        'Plumbers',
        'Roof Inspectors & Installers',
        'Renovators',
        'Patio Coverings',
        'Solar Installation & Solar Panel Cleaning',
        'Education',
        'Adult & Continuing Education',
        'Childcare',
        'Colleges & Universities',
        'Child Care & Day Care',
        'Early Childhood Education',
        'Educational Resources',
        'Language Schools',
        'Middle Schools & High Schools',
        'Private Schools',
        'Vocational & Technical School',
        'Other Educational',
        'Entertainment',
        'Artists, Writers',
        'Event Planners & Supplies',
        'Golf Courses',
        'Bowling Alley',
        'Gaming Zone',
        'Sporting Club',
        'Fitness Club & gym',
        'Boxing Club',
        'Cinema & Movies Productions',
        'Food & Dining',
        'Desserts, Catering & Supplies',
        'Fast Food & Carry Out',
        'Grocery',
        'Beverage & Tobacco',
        'Cafe & Club',
        'Pub',
        'Bakery',
        'Restaurants',
        'Health & Medicine',
        'Acupuncture',
        'Assisted Living & Home Health Care',
        'Rehab Center & Mental Health',
        'Audiologist',
        'Chiropractic Clinics & Medical Centers',
        'Dental',
        'Diet & Nutrition',
        'General Physician',
        'Laboratory, Imaging & Diagnostic',
        'Medical Supply Store',
        'Massage Therapy',
        'Nurse',
        'Optical',
        'Pharmacy, Drug & Vitamin Stores',
        'Physical Therapy',
        'Physicians & Assistants',
        'Podiatry',
        'Social Worker',
        'Animal Hospital',
        'Veterinary & Animal Surgeons',
        'IT Services',
        'Information technology company',
        'Digital Marketing',
        'Website Design & Development',
        'Social Media Management',
        'Web Hosting & Server Specialists',
        'IT Management & Service',
        'IT Outsourcing Service',
        'Cyber Security Consultants',
        'Software Development',
        'Mobile Application Development',
        'Computer security company',
        'Legal & Financial',
        'Accountants',
        'Attorneys',
        'Banks & Credit Unions',
        'Currency Exchange',
        'Debt Relief Services',
        'Financial Advising',
        'Financial Institutions',
        'Financial Services',
        'Insurance',
        'Mortgage Lenders',
        'Tax Preparation & Service',
        'Other Legal',
        'Manufacturing, Wholesale, Distribution',
        'Distribution, Import/Export',
        'Manufacturing',
        'Wholesale',
        'Merchants (Retail)',
        'Cards & Gifts',
        'Mobile Phone Shop',
        'Electronics retail company',
        'Flower Shop',
        'Concept store',
        'Clothing & Accessories',
        'Department Stores,',
        'Sporting Goods',
        'General Stores',
        'Jewelry',
        'Shoes',
        'Fashion Store',
        'E-Commerce and Online Store',
        'Miscellaneous',
        'Civic Groups',
        'Funeral Service Providers & Cemeteries',
        'Utility Companies',
        'Miscellaneous',
        'Personal Care & Services',
        'Animal Care & Supplies',
        'Barber & Beauty Salons',
        'Beauty Supplies',
        'Dry Cleaners & Laundromats',
        'Exercise & Fitness',
        'Massage & Body Works',
        'Nail Salons',
        'Shoemaker & Shoe Repairs',
        'Tailors',
        'Real Estate',
        'Agencies & Brokerage',
        'Agents & Brokers',
        'Realtors',
        'Apartment & Home Rental',
        'Mortgage Broker & Lender',
        'Property Management',
        'Title Company',
        'Travel & Transportation',
        'Hotel, Motel & Extended Stay',
        'Moving & Storage',
        'Limo Hire & Airport transfers',
        'Packaging & Shipping',
        'Transportation',
        'Taxi and Ride Hailing',
        'Ride sharing Company',
        'Travel & Tourism'
    ];

    options = options.map((option) => {
        return {
            label: option,
            value: option
        }
    });

    const onChange = (val) => {
        setSelectedOptions(val);
        let temp = val.map((option) => {
            return option.value;
        });
        console.log(temp);
    }

    const {values, errors, touched, handlerBlur, handleChange, handleSubmit} = useFormik({
        initialValues: businessData,
        validationSchema: formSchema,
        onSubmit: (values) => {
            const data = {
                businessName: values.Name,
                businessEmail: values.Email,
                businessWebsite: values.Website,
                businessPhone: values.Phone,
                businessStreet: values.Street,
                businessCity: values.City,
                businessState: values.State,
                businessZipcode: values.Zipcode,
                businessCountry: values.Country,
            };
            axios.put(`business/updateBusinessById/${businessData._id}`, data, {
                headers: {
                    // Multer only parses "multipart/form-data" requests
                    'Content-Type': 'multipart/form-data'
                }
            }).then((res) => {
                console.log('response: ',res);
                axios.get(`business/GetBusinessById/${businessData._id}`).then((res) => {
                    res.data.Data.Image = `${imageUrl}${res.data.Data.Image}`;
                    window.sessionStorage.setItem('business', JSON.stringify(res.data.Data));
                }).catch((err) => {
                    console.log('Error');
                })
                toast('Details Updated');
                setShow(false);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }).catch((error) => {
                toast('Something went wrong!');
                console.log(error);
            })
            console.log(data);
            console.log(values);
        }
    })

    const toggleShow = () => {
        setShow(!show);
    }
    return (
        <>
            <ToastContainer/>
            <button className='btn btn-primary' onClick={toggleShow}>
                Edit Business
            </button>
            <Modal size={'lg'} show={show} onHide={toggleShow} animation={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Business Details</Modal.Title>
                </Modal.Header>

                <Form onSubmit={handleSubmit}>
                    <Modal.Body>
                        <Row>
                            <Col md='6' className='mb-2'>
                                <h5>Business Name:</h5>
                                <Form.Control
                                    placeholder='Enter Name'
                                    value={values.Name}
                                    name="Name"
                                    onBlur={handlerBlur}
                                    onChange={handleChange}
                                />
                                {
                                    errors.Name != "" && errors.Name != undefined ? (
                                            <Form.Text className='text-danger'>
                                                {errors.Name}
                                            </Form.Text>
                                        )
                                        :
                                        ''
                                }
                            </Col>
                            <Col md='6' className='mb-2'>
                                <h5>Categories:</h5>
                                {/*<Form.Control*/}
                                {/*    placeholder='Select Categories'*/}
                                {/*    value={values.Categories}*/}
                                {/*    name="Categories"*/}
                                {/*    onBlur={handlerBlur}*/}
                                {/*    onChange={handleChange}*/}
                                {/*/>*/}
                                <Select
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    isMulti
                                    value={''}
                                    name={'Categories'}
                                    isOptionDisabled={() => selectedOptions.length >= 3}
                                    options={options}
                                    onChange={onChange}
                                />
                            </Col>

                            <hr></hr>
                            <Row>
                                <p className="p" style={{fontSize: '1.4rem'}}>
                                    <b><u>Contact Info</u></b>
                                </p>
                            </Row>
                            <Col md='6' className='mb-2'>
                                <h5>Email:</h5>
                                <Form.Control
                                    placeholder='Enter Email'
                                    value={values.Email}
                                    name="Email"
                                    onBlur={handlerBlur}
                                    onChange={handleChange}
                                />
                                {
                                    errors.Email != "" && errors.Email != undefined ? (
                                            <Form.Text className='text-danger'>
                                                {errors.Email}
                                            </Form.Text>
                                        )
                                        :
                                        ''
                                }
                            </Col>
                            <Col md='6' className='mb-2'>
                                <h5>Website:</h5>
                                <Form.Control
                                    placeholder='Enter Website'
                                    value={values.Website}
                                    name="Website"
                                    onBlur={handlerBlur}
                                    onChange={handleChange}
                                />
                                {
                                    errors.Email != "" && errors.Website != undefined ? (
                                            <Form.Text className='text-danger'>
                                                {errors.Website}
                                            </Form.Text>
                                        )
                                        :
                                        ''
                                }
                            </Col>
                            <Col md='6' className='mb-2'>
                                <h5>Phone:</h5>
                                <InputMask mask="(999) 999-999" value={values.Phone} name={"Phone"}
                                           onChange={handleChange} onBlur={handlerBlur}>
                                    {(inputProps) =>
                                        <input type="tel"
                                               className='form-control'
                                            // name={"Phone"}
                                            // placeholder="(123) 456-78790"
                                            // onChange={handleChange}
                                            // onBlur = {handlerBlur}
                                               {...inputProps} />
                                    }
                                </InputMask>
                                {
                                    errors.Email != "" && errors.Website != undefined ? (
                                            <Form.Text className='text-danger'>
                                                {errors.Website}
                                            </Form.Text>
                                        )
                                        :
                                        ''
                                }
                            </Col>
                            <hr></hr>
                            <Row>
                                <p className="p" style={{fontSize: '1.4rem'}}>
                                    <b><u>Business Address</u></b>
                                </p>
                            </Row>
                            <Col md='6' className='mb-2'>
                                <h5>Street:</h5>
                                <Form.Control
                                    placeholder='Enter Street'
                                    value={values.Street}
                                    name="Street"
                                    onBlur={handlerBlur}
                                    onChange={handleChange}
                                />
                                {
                                    errors.Street != "" && errors.Street != undefined ? (
                                            <Form.Text className='text-danger'>
                                                {errors.Website}
                                            </Form.Text>
                                        )
                                        :
                                        ''
                                }
                            </Col>
                            <Col md='6' className='mb-2'>
                                <h5>City:</h5>
                                <Form.Control
                                    placeholder='Enter City'
                                    value={values.City}
                                    name="City"
                                    onBlur={handlerBlur}
                                    onChange={handleChange}
                                />
                                {
                                    errors.Email != "" && errors.Website != undefined ? (
                                            <Form.Text className='text-danger'>
                                                {errors.Website}
                                            </Form.Text>
                                        )
                                        :
                                        ''
                                }
                            </Col>
                            <Col md='6' className='mb-2'>
                                <h5>State:</h5>
                                <select className='form-control' onChange={handleChange} value={values.State}
                                        name={"State"}>
                                    <option value="NA">NA</option>
                                    <option value="Alabama">Alabama</option>
                                    <option value="Alaska">Alaska</option>
                                    <option value="Arizona">Arizona</option>
                                    <option value="Arkansas">Arkansas</option>
                                    <option value="California">California</option>
                                    <option value="Colorado">Colorado</option>
                                    <option value="Connecticut">Connecticut</option>
                                    <option value="Delaware">Delaware</option>
                                    <option value="Florida">Florida</option>
                                    <option value="Georgia">Georgia</option>
                                    <option value="Hawaii">Hawaii</option>
                                    <option value="Idaho">Idaho</option>
                                    <option value="Illinois">Illinois</option>
                                    <option value="Indiana">Indiana</option>
                                    <option value="Iowa">Iowa</option>
                                    <option value="Kansas">Kansas</option>
                                    <option value="Kentucky">Kentucky</option>
                                    <option value="Louisiana">Louisiana</option>
                                    <option value="Maine">Maine</option>
                                    <option value="Maryland">Maryland</option>
                                    <option value="Massachusetts">Massachusetts</option>
                                    <option value="Michigan">Michigan</option>
                                    <option value="Minnesota">Minnesota</option>
                                    <option value="Mississippi">Mississippi</option>
                                    <option value="Missouri">Missouri</option>
                                    <option value="Montana">Montana</option>
                                    <option value="Nebraska">Nebraska</option>
                                    <option value="Nevada">Nevada</option>
                                    <option value="New Hampshire">New Hampshire</option>
                                    <option value="New Jersey">New Jersey</option>
                                    <option value="New Mexico">New Mexico</option>
                                    <option value="New York">New York</option>
                                    <option value="North Carolina">North Carolina</option>
                                    <option value="North Dakota">North Dakota</option>
                                    <option value="Ohio">Ohio</option>
                                    <option value="Oklahoma">Oklahoma</option>
                                    <option value="Oregon">Oregon</option>
                                    <option value="Pennsylvania">Pennsylvania</option>
                                    <option value="Rhode Island">Rhode Island</option>
                                    <option value="South Carolina">South Carolina</option>
                                    <option value="South Dakota">South Dakota</option>
                                    <option value="Tennessee">Tennessee</option>
                                    <option value="Texas">Texas</option>
                                    <option value="Utah">Utah</option>
                                    <option value="Vermont">Vermont</option>
                                    <option value="Virginia">Virginia</option>
                                    <option value="Washington">Washington</option>
                                    <option value="West Virginia">West Virginia</option>
                                    <option value="Wisconsin">Wisconsin</option>
                                    <option value="Wyoming">Wyoming</option>
                                </select>
                            </Col>
                            <Col md='6' className='mb-2'>
                                <h5>ZipCode:</h5>
                                <Form.Control
                                    placeholder='Enter Zipcode'
                                    value={values.Zipcode}
                                    name="Zipcode"
                                    onBlur={handlerBlur}
                                    onChange={handleChange}
                                />
                            </Col>
                            <Col md='6' className='mb-2'>
                                <h5>Country:</h5>
                                <Form.Control
                                    placeholder='Enter Country'
                                    value={values.Country}
                                    name="Country"
                                    onBlur={handlerBlur}
                                    onChange={handleChange}
                                />
                            </Col>

                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button type="button" variant="secondary" onClick={toggleShow}>
                            Close
                        </Button>
                        <Button type="submit" variant="primary">
                            Save Changes
                        </Button>
                    </Modal.Footer>

                </Form>
            </Modal>
        </>
    )
}

export default BusinessEditModal
